import React from "react";
import classnames from "classnames";
import "./Button.css";

export const Button = ({
  children,
  disabled = false,
  primary = false,
  search = false,
  link = false,
  type = "button",
  className,
  ...rest
}) => {
  return (
    <button
      type={type}
      disabled={disabled}
      aria-disabled={disabled}
      className={classnames(
        "Button",
        { disabled, primary, search, link },
        className
      )}
      {...rest}
    >
      {children}
    </button>
  );
};



// WEBPACK FOOTER //
// ./src/components/Button.js